import React, { useState, useContext } from "react";
import "../../../../css/CRUDModal.css";
import DeleteFranchiseConfirmationModal from "../DeleteFranchiseConfirmationModal";
import axios from "axios";
import { BankNameContext } from "../../../../context/BankNameContext";
import CustomAlert from "../../../../helpers/CustomAlert";
import { toast } from "react-toastify";
import {apiList, baseAuthUrl, baseUrl} from "../../../../helpers/apiList";
import { axiosGetApi } from "../../../../helpers/interceptorServices";
import AadhaarInput from "../../../../components/common/AadhaarInput";
import { FaEye } from "react-icons/fa";

const AddFranchise = ({
  show,
  handleClose,
  editData,
  action,
  fetchCustomerData,
  payloadData,
  setPayloadData,
  loggedInUserName,
  CloseCreate,
  handleNext,
}) => {
  // const loggedInUserName = sessionStorage.getItem("username");

  const [errors, setErrors] = useState({
    franchiseName: "",
    emailId: "",
    addr1: "",
    addr2: "",
    addr3: "",
    pinCode: "",
    primaryContactName: "",
    primaryContactMobile: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    gstNumber: "",
    aadharNumber: "",
    panNumber: "",
    companyPanNumber: "",
    franchiseType: "",
  });
  const { bankNames, loading, error } = useContext(BankNameContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [validGSTNo, setValidGSTNo] = useState(false);
  const [validCompanyPanNo, setValidCompanyPanNo] = useState(false);

  // ----------------- added this -----------------
  const [showDocModal, setShowDocModal] = useState(false);
  const [docPath, setDocPath] = useState("");
  const [docLabel, setDocLabel] = useState("");
  const [docMime, setDocMime] = useState("");
  const [activeDoc, setActiveDoc] = useState("GST");
  const [gstApproved, setGstApproved] = useState(false);
  const [panApproved, setPanApproved] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // -------------------------------------------

  // Start dragging
  const handleMouseDown = (e) => {
    if (zoomLevel <= 1) return; // only allow drag when zoomed in
    setIsDragging(true);
    setDragStart({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    e.preventDefault();
  };

  // Move document
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const newX = e.clientX - dragStart.x;
    const newY = e.clientY - dragStart.y;
    setOffset({ x: newX, y: newY });
  };

  // Stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  React.useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isDragging, dragStart]);

  if (loading) {
    return <p>Loading data...</p>;
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (
      id === "franchiseName" ||
      id === "ifscCode" ||
      id === "gstNumber" ||
      id === "panNumber" ||
      id === "companyPanNumber"
    ) {
      updatedValue = value.toUpperCase();
    } else if (id === "emailId") {
      updatedValue = value.toLowerCase();
    } else if (
      id === "primaryContactMobile" ||
      id === "secondContactPersonMobileNo" ||
      id === "accountNo"
    ) {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setPayloadData((prev) => {
      const newPayload = { ...prev, [id]: updatedValue };

      if (id === "gstNumber") {
        if (updatedValue.length === 15) {
          const derivedPan = updatedValue.slice(2, 12);
          newPayload.companyPanNumber = derivedPan;
        } else {
          newPayload.companyPanNumber = "";
        }
      }

      return newPayload;
    });

    if (id === "pinCode") {
      validatePinCode(value);
    }

    if (id === "franchiseType") {
      const trimmedValue = updatedValue.trim();
      const isValidAuthPerPan =
        trimmedValue === "Private Limited" ||
        trimmedValue === "Public Limited" ||
        trimmedValue === "LLP";

      setErrors((prevErrors) => ({
        ...prevErrors,
        panNumber:
          isValidAuthPerPan &&
          payloadData?.companyPanNumber === payloadData?.panNumber
            ? "Company PAN and Authorised PAN must be different"
            : "",
      }));
    }
  };

  const handleNextWithValidation = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    console.log("::validationErrors::", validationErrors);

    // If there are no validation errors, proceed to next step
    if (
      Object.keys(validationErrors).length === 0 ||
      action === "view" ||
      action === "delete" ||
      action === "auth" ||
      (action === "modify" && !payloadData.aadharNumberRaw)
    ) {
      handleNext(); // Call the original handleNext function
    } else {
      // Show error message or toast notification
      toast.error("Please fix all validation errors before proceeding", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Scroll to first error field
      const firstErrorField = document.querySelector(".error");
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    // Name validation (between 2 and 50 characters)
    payloadData.franchiseName = payloadData.franchiseName.trim();
    if (!payloadData.franchiseName) {
      newErrors.franchiseName = "Franchise Name is required";
    } else if (
      !/^[A-Za-z0-9@&.,'\- ]+$/.test(payloadData.franchiseName) ||
      payloadData.franchiseName.length < 2 ||
      payloadData.franchiseName.length > 50
    ) {
      newErrors.franchiseName =
        "Franchise name must be valid and between 2 and 50 characters";
    } else if (/^(.)\1{2,}$/.test(payloadData.franchiseName)) {
      newErrors.franchiseName =
        "Franchise name cannot be made of a single repeated character";
    }

    // Email validation (required and valid email)
    if (!payloadData.emailId) {
      newErrors.emailId = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
        payloadData.emailId
      ) ||
      /\.com\./.test(payloadData.emailId) ||
      /\.co\.[a-zA-Z]{2}\./.test(payloadData.emailId)
    ) {
      newErrors.emailId = "Enter valid email ending with .com .co.xx or .in";
    }

    // Address validation
    payloadData.addr1 = payloadData.addr1.trim();
    if (!payloadData.addr1) {
      newErrors.addr1 = "Address is required";
    } else if (payloadData.addr1.length < 5 || payloadData.addr1.length > 150) {
      newErrors.addr1 = "Address1 must be between 5 and 150 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        payloadData.addr1
      )
    ) {
      newErrors.addr1 =
        "Address 1 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.addr1)) {
      newErrors.addr1 = "Address 1 must contain at least one letter";
    }

    // Address 2 validation (required)
    payloadData.addr2 = payloadData.addr2.trim();
    if (!payloadData.addr2) {
      newErrors.addr2 = "Address is required";
    } else if (payloadData.addr2.length < 5 || payloadData.addr2.length > 150) {
      newErrors.addr2 = "Address2 must be between 5 and 50 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        payloadData.addr2
      )
    ) {
      newErrors.addr2 =
        "Address 2 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.addr2)) {
      newErrors.addr2 = "Address 2 must contain at least one letter";
    }

    // Address 3 validation (optional)
    payloadData.addr3 = payloadData.addr3.trim();
    if (payloadData.addr3) {
      if (payloadData.addr3.length < 5 || payloadData.addr3.length > 150) {
        newErrors.addr3 = "Address 3 must be between 5 and 150 characters";
      } else if (
        !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
          payloadData.addr3
        )
      ) {
        newErrors.addr3 =
          "Address 3 contains invalid characters or starts/ends with spaces";
      } else if (!/[A-Za-z]/.test(payloadData.addr3)) {
        newErrors.addr3 = "Address 3 must contain at least one letter";
      }
    }
    if (!payloadData.pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^[1-9]\d{5}$/.test(payloadData.pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits and must not start with 0";
    }

    // First contact person name validation (between 2 and 50 characters)
    payloadData.primaryContactName = payloadData.primaryContactName.trim();
    if (!payloadData.primaryContactName) {
      newErrors.primaryContactName = "Contact person name is required";
    } else if (
      !/^[A-Za-z@&.,'\- ]+$/.test(payloadData.primaryContactName) ||
      payloadData.primaryContactName.length < 2 ||
      payloadData.primaryContactName.length > 50
    ) {
      newErrors.primaryContactName =
        "Contact person name must be between 2 and 50 characters and contain only letters";
    } else if (
      !/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(payloadData.primaryContactName)
    ) {
      newErrors.primaryContactName =
        "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
    } else if (
      /^([A-Za-z])\1+$/.test(
        payloadData.primaryContactName.replace(/[ .-]/g, "")
      )
    ) {
      newErrors.primaryContactName =
        "Contact person name cannot consist of the same letter repeated";
    }

    // First contact person mobile number validation
    if (!payloadData.primaryContactMobile) {
      newErrors.primaryContactMobile =
        "Contact person mobile number is required";
    } else if (!/^[789]\d{9}$/.test(payloadData.primaryContactMobile)) {
      newErrors.primaryContactMobile =
        "Mobile number must be 10 digits and start with 7, 8, or 9";
    } else if (/^(\d)\1{9}$/.test(payloadData.primaryContactMobile)) {
      newErrors.primaryContactMobile =
        "Mobile number cannot have all repeated digits";
    } else if (
      payloadData.primaryContactMobile === "1234567890" ||
      payloadData.primaryContactMobile === "9876543210"
    ) {
      newErrors.primaryContactMobile =
        "Mobile number cannot be a simple sequence";
    }

    // Aadhar Number Validation
    const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";
    if (!aadharRaw) {
      newErrors.aadharNumber = "Aadhar Number is required";
    } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber =
        "Aadhar Number must be exactly 12 digits and start with 2-9";
    } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber = "Aadhar Number cannot have all repeated digits";
    }

    // PAN Number Validation
    if (!payloadData.panNumber) {
      newErrors.panNumber = "PAN Number is required";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(payloadData.panNumber)) {
      newErrors.panNumber = "Invalid PAN Number format";
    }

    // Company PAN Number Validation
    if (!payloadData.companyPanNumber) {
      newErrors.companyPanNumber = "PAN Number is required";
    } else if (
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(payloadData.companyPanNumber)
    ) {
      newErrors.companyPanNumber = "Invalid PAN Number format";
    }

    // Company Type validation
    if (!payloadData.franchiseType) {
      newErrors.franchiseType = "Company Type is required";
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value.trim();

    switch (id) {
      case "franchiseName":
        if (!trimmedValue) {
          fieldErrors.franchiseName = "Franchise name is required";
        } else if (
          !/^[A-Za-z0-9@&.,'\- ]+$/.test(trimmedValue) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.franchiseName =
            "Franchise name must be valid and between 2 and 50 characters";
        } else if (/^(.)\1{2,}$/.test(trimmedValue)) {
          fieldErrors.franchiseName =
            "Franchise name cannot be made of a single repeated character";
        } else {
          fieldErrors.franchiseName = ""; // ✅ Clear error if valid
        }
        break;

      case "emailId":
        if (!trimmedValue) {
          fieldErrors.emailId = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
            trimmedValue
          ) ||
          /\.com\./.test(trimmedValue) ||
          /\.co\.[a-zA-Z]{2}\./.test(trimmedValue)
        ) {
          fieldErrors.emailId =
            "Enter valid email ending with .com .co.xx or .in";
        } else {
          fieldErrors.emailId = "";
        }
        break;

      case "addr1":
        if (!trimmedValue) {
          fieldErrors.addr1 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.addr1 = "Address 1 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.addr1 =
            "Address 1 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.addr1 = "Address 1 must contain at least one letter";
        } else {
          fieldErrors.addr1 = "";
        }
        break;

      case "addr2":
        if (!trimmedValue) {
          fieldErrors.addr2 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.addr2 = "Address 2 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.addr2 =
            "Address 2 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.addr2 = "Address 2 must contain at least one letter";
        } else {
          fieldErrors.addr2 = "";
        }
        break;

      case "addr3":
        if (trimmedValue) {
          if (trimmedValue.length < 5 || trimmedValue.length > 150) {
            fieldErrors.addr3 =
              "Address 3 must be between 5 and 150 characters";
          } else if (
            !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
              trimmedValue
            )
          ) {
            fieldErrors.addr3 =
              "Address 3 contains invalid characters or starts/ends with spaces";
          } else if (!/[A-Za-z]/.test(trimmedValue)) {
            fieldErrors.addr3 = "Address 3 must contain at least one letter";
          } else {
            fieldErrors.addr3 = "";
          }
        } else {
          fieldErrors.addr3 = "";
        }
        break;

      case "pinCode":
        if (!trimmedValue) {
          fieldErrors.pinCode = "Pincode is required";
        } else if (!/^[1-9]\d{5}$/.test(trimmedValue)) {
          fieldErrors.pinCode =
            "Pincode must be 6 digits and must not start with 0";
        } else {
          fieldErrors.pinCode = "";
        }
        break;

      case "primaryContactName":
        if (!trimmedValue) {
          fieldErrors.primaryContactName = "Contact person name is required";
        } else if (trimmedValue.length < 2 || trimmedValue.length > 50) {
          fieldErrors.primaryContactName =
            "Contact person name must be between 2 and 50 characters";
        } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(trimmedValue)) {
          fieldErrors.primaryContactName =
            "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
        } else if (/^([A-Za-z])\1+$/.test(trimmedValue.replace(/[ .-]/g, ""))) {
          fieldErrors.primaryContactName =
            "Contact person name cannot consist of the same letter repeated";
        } else {
          fieldErrors.primaryContactName = "";
        }
        break;

      case "primaryContactMobile":
        if (!trimmedValue) {
          fieldErrors.primaryContactMobile =
            "Contact person mobile number is required";
        } else if (!/^[789]\d{9}$/.test(trimmedValue)) {
          fieldErrors.primaryContactMobile =
            "Mobile number must be 10 digits and start with 7, 8, or 9";
        } else if (/^(\d)\1{9}$/.test(trimmedValue)) {
          fieldErrors.primaryContactMobile =
            "Mobile number cannot have all repeated digits";
        } else if (
          trimmedValue === "1234567890" ||
          trimmedValue === "9876543210"
        ) {
          fieldErrors.primaryContactMobile =
            "Mobile number cannot be a simple sequence";
        } else {
          fieldErrors.primaryContactMobile = "";
        }
        break;

      case "gstNumber":
        if (!trimmedValue) {
          fieldErrors.gstNumber = "GST Number is required";
        } else if (
          !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.gstNumber = "Invalid GST Number format";
        } else {
          fieldErrors.gstNumber = "";
          if (trimmedValue.length === 15) {
            const derivedPan = trimmedValue.slice(2, 12);
            setPayloadData((prev) => ({
              ...prev,
              companyPanNumber: derivedPan,
            }));
          }
        }
        break;

      case "aadharNumber":
        const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";

        if (!aadharRaw) {
          fieldErrors.aadharNumber = "Aadhar Number is required";
        } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number must be exactly 12 digits and start with 2-9";
        } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number cannot have all repeated digits";
        } else {
          fieldErrors.aadharNumber = "";
        }
        break;

      case "panNumber":
        if (!trimmedValue) {
          fieldErrors.panNumber = "PAN Number is required";
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(trimmedValue)) {
          fieldErrors.panNumber = "Invalid PAN Number format";
        } else if (
          isValidAuthPerPan &&
          payloadData?.companyPanNumber === trimmedValue
        ) {
          fieldErrors.panNumber =
            "Company PAN and Authorised PAN must be different";
        } else {
          fieldErrors.panNumber = "";
        }
        break;

      case "franchiseType":
        if (!trimmedValue) {
          fieldErrors.franchiseType = "Company Type is required";
        } else {
          fieldErrors.franchiseType = "";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits";
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseAuthUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || "Enter a valid Pincode";
          } else {
            const pinCodeData = data[0];
            const { cityName, state } = pinCodeData;
            setPayloadData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
            }));

            delete newErrors.pinCode;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          newErrors.pinCode = "Error fetching pincode data";
          setErrors(newErrors);
        });
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleCheckGstNumber = async () => {
    const gstNumber = payloadData?.gstNumber;

    if (!gstNumber || gstNumber.length !== 15) {
      CustomAlert({
        title: "Invalid GST",
        text: "Please enter a valid 15-digit GST Number.",
        icon: "warning",
        confirmButtonText: "Okay",
      });
      return;
    }

    try {
      const response = await axiosGetApi(
        `${apiList.GET_FRANCHISE_GST_STATUS}/${gstNumber}`
      );

      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        CustomAlert({
          title: response?.data?.message,
          // text: response?.data?.message || "GST Number exists.",
          icon: "info",
          confirmButtonText: "Retry",
        });
        setValidGSTNo(false);
      } else if (respCode === "01") {
        CustomAlert({
          title: "Valid GST",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setValidGSTNo(true);
        setGstApproved(true);
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
        setValidGSTNo(false);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while checking GST number.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleCheckConpanyPanNumber = async () => {
    const companyPanNumber = payloadData?.companyPanNumber;

    if (!companyPanNumber || companyPanNumber.length !== 10) {
      CustomAlert({
        title: "Invalid PAN",
        text: "Please enter a valid 10-digit PAN Number.",
        icon: "warning",
        confirmButtonText: "Okay",
      });
      return;
    }

    try {
      const response = await axiosGetApi(
        `${apiList.GET_FRANCHISE_COMPANY_PAN_STATUS}/${companyPanNumber}`
      );

      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        CustomAlert({
          title: response?.data?.message,
          // text: response?.data?.message || "GST Number exists.",
          icon: "info",
          confirmButtonText: "Retry",
        });
        setValidCompanyPanNo(false);
      } else if (respCode === "01") {
        CustomAlert({
          title: "Valid",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setValidCompanyPanNo(true);
        setPanApproved(true);
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
        setValidCompanyPanNo(false);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while checking Company Pan number.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };
  const fieldDisabled = (validGSTNo && validCompanyPanNo) || isEditMode;

  const isValidAuthPerPan =
    payloadData?.franchiseType === "Private Limited" ||
    payloadData?.franchiseType === "Public Limited" ||
    payloadData?.franchiseType === "LLP";

  const openDocument = (filePath, label = "Document") => {
    if (!filePath) {
      CustomAlert({
        title: `${label} Not Found`,
        text: `No ${label} document uploaded.`,
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    if (label.toLowerCase().includes("gst")) {
      setActiveDoc("GST");
    } else if (label.toLowerCase().includes("pan")) {
      setActiveDoc("PAN");
    }

    // determine simple mime / extension
    const ext = (filePath.split(".").pop() || "").toLowerCase();
    setDocMime(ext);
    setDocPath(filePath);
    setDocLabel(label);
    setShowDocModal(true);
  };

  const closeDocumentModal = () => {
    setShowDocModal(false);
    setDocPath("");
    setDocLabel("");
    setDocMime("");
  };

  const gstFilePath = editData?.gstCertificateFilePath;
  const panFilePath = editData?.panFilePath;

  return (
    <>
      <form>
        <div className="modal-body">
          {/* GST Number & Retailer PAN No on the same row */}
          <div className="row mb-3">
            {/* GST Number */}
            <div className="col-md-6">
              <div
                className="form-group"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <label
                  htmlFor="gstNumber"
                  style={{ width: "150px" }}
                  className="text-sm font-medium text-gray-700"
                >
                  GST Number<span style={{ color: "red" }}>*</span>
                </label>

                <div className="relative flex-grow">
                  <i className="fa fa-file-invoice absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] !rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="GST Number"
                    id="gstNumber"
                    value={payloadData.gstNumber}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || isEditMode
                    }
                    maxLength={15}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>

                {!isViewMode && !isAuthMode ? (
                  gstApproved ? (
                    <button
                      type="button"
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#16A34A",
                        borderColor: "#16A34A",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        cursor: "default",
                        transition: "all 0.3s ease",
                        fontWeight: 500,
                      }}
                      disabled
                    >
                      Approved
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={handleCheckGstNumber}
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#FF6A13",
                        borderColor: "#FF6A13",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        fontWeight: 500,
                        transition: "all 0.3s ease",
                      }}
                      disabled={action !== "add"}
                    >
                      Check
                    </button>
                  )
                ) : (
                  <FaEye
                    className="text-gray-600 cursor-pointer hover:text-orange-500"
                    onClick={() => openDocument(gstFilePath, "GST Certificate")}
                  />
                )}
              </div>
            </div>

            {/* Retailer PAN No */}
            <div className="col-md-6">
              <div
                className="form-group"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <label
                  htmlFor="companyPanNumber"
                  style={{ width: "150px" }}
                  className="text-sm font-medium text-gray-700"
                >
                  Franchise PAN No<span style={{ color: "red" }}>*</span>
                </label>

                <div className="relative flex-grow">
                  <i className="fa fa-id-card absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Franchise PAN No"
                    id="companyPanNumber"
                    value={payloadData.companyPanNumber}
                    disabled={isViewMode || isDeleteMode || isAuthMode}
                    maxLength={15}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>

                {!isViewMode && !isAuthMode ? (
                  panApproved ? (
                    <button
                      type="button"
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#16A34A",
                        borderColor: "#16A34A",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        cursor: "default",
                        transition: "all 0.3s ease",
                        fontWeight: 500,
                      }}
                      disabled
                    >
                      Approved
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#FF6A13",
                        borderColor: "#FF6A13",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        fontWeight: 500,
                        transition: "all 0.3s ease",
                      }}
                      onClick={handleCheckConpanyPanNumber}
                      disabled={action !== "add"}
                    >
                      Check
                    </button>
                  )
                ) : (
                  <FaEye
                    className="text-gray-600 cursor-pointer hover:text-orange-500"
                    onClick={() => openDocument(panFilePath, "PAN Document")}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Three-column grid for remaining fields */}
          <div className="row mb-3 mt-1">
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="franchiseName"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Franchise Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[36px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Enter Franchise Name"
                    id="franchiseName"
                    value={payloadData.franchiseName}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.franchiseName ? (
                  <span className="error">{errors.franchiseName}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="emailId"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Franchise Email Id<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-envelope absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="email"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Enter Franchise Email Id"
                    id="emailId"
                    value={payloadData.emailId}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.emailId ? (
                  <span className="error">{errors.emailId}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="addr1"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Address 1<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Address 1"
                    id="addr1"
                    value={payloadData.addr1}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) && errors.addr1 ? (
                  <span className="error">{errors.addr1}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="addr2"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Address 2<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Address 2"
                    id="addr2"
                    value={payloadData.addr2}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) && errors.addr2 ? (
                  <span className="error">{errors.addr2}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="addr3"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Address 3
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Address 3"
                    id="addr3"
                    value={payloadData.addr3}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) && errors.addr3 ? (
                  <span className="error">{errors.addr3}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="pinCode"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Pin Code<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Pin Code"
                    id="pinCode"
                    value={payloadData.pinCode}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,6}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.pinCode ? (
                  <span className="error">{errors.pinCode}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="state"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  State
                </label>
                <div className="relative">
                  <i className="fa fa-flag absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    id="state"
                    value={payloadData.state || "State"}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="city"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  City
                </label>
                <div className="relative">
                  <i className="fa fa-city absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    id="city"
                    value={payloadData.city || "City"}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="primaryContactName"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Contact Person Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-user absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Contact Person Name"
                    id="primaryContactName"
                    value={payloadData.primaryContactName}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={50}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z .-]*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.primaryContactName ? (
                  <span className="error">{errors.primaryContactName}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="primaryContactMobile"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Contact Person Mobile No.
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-phone absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Contact Person Mobile No."
                    id="primaryContactMobile"
                    value={payloadData.primaryContactMobile}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.primaryContactMobile ? (
                  <span className="error">{errors.primaryContactMobile}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="franchiseType"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Franchise Type<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-phone absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <select
                    id="franchiseType"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    value={payloadData.franchiseType}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Select Type</option>
                    <option value="Proprietor">Proprietor</option>
                    <option value="Private Limited">Private Limited</option>
                    <option value="Individual">Individual</option>
                    <option value="LLP">LLP</option>
                    <option value="Public Limited">Public Limited</option>
                  </select>
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.franchiseType ? (
                  <span className="error">{errors.franchiseType}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="panNumber"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Authorize Person PAN No<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-id-card absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Authorize Person PAN No"
                    id="panNumber"
                    value={payloadData.panNumber}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={10}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.panNumber ? (
                  <span className="error">{errors.panNumber}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="aadharNumber"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Aadhar Number<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-id-badge absolute left-3 top-[9px] text-[#FF702B] text-sm"></i>
                  <AadhaarInput
                    id="aadharNumber"
                    value={payloadData.aadharNumber}
                    onChange={(masked, raw) => {
                      setPayloadData((prev) => ({
                        ...prev,
                        aadharNumber: masked, // for display
                        aadharNumberRaw: raw, // for validation
                      }));
                    }}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    error={
                      !(
                        isViewMode ||
                        isDeleteMode ||
                        isAuthMode ||
                        (action === "modify" && !payloadData.aadharNumberRaw)
                      ) && errors.aadharNumber
                        ? errors.aadharNumber
                        : null
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scoped-modal modal-footer !justify-center gap-3">
          <button
            type="button"
            className="btn btn-back w-[133px] !rounded-lg"
            onClick={CloseCreate}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleNextWithValidation}
            className="btn btn-submit w-[133px] !rounded-lg"
            disabled={!fieldDisabled && action === "add"}
          >
            Next
          </button>
          <DeleteFranchiseConfirmationModal
            isOpen={isModalOpen}
            onClose={closeModal}
            editData={editData}
            fetchCustomerData={fetchCustomerData}
            handleClose={handleClose}
          />
        </div>

        {showDocModal && (
          <>
            <div
              className={`modal fade show`}
              tabIndex="-1"
              role="dialog"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <div
                className="modal-dialog modal-lg"
                role="document"
                style={{ maxWidth: 900 }}
              >
                <div className="modal-content shadow-lg rounded-3 overflow-hidden">
                  {/* ---------------- Dynamic Header ---------------- */}
                  <div
                    style={{
                      backgroundColor: "#FFF4EE",
                      padding: "20px 0 16px",
                      borderBottom: "1px solid #FFD8C2",
                      position: "relative",
                      textAlign: "center",
                    }}
                  >
                    {/* Header content based on activeDoc */}
                    {activeDoc === "GST" && (
                      <div>
                        <div
                          style={{
                            width: "54px",
                            height: "54px",
                            backgroundColor: "#FF6A13",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            fontSize: "22px",
                            margin: "0 auto 8px",
                            boxShadow: "0 3px 6px rgba(255,106,19,0.4)",
                          }}
                        >
                          <i className="fa fa-file-invoice"></i>
                        </div>
                        <h5
                          style={{
                            color: "#FF6A13",
                            fontWeight: 600,
                            fontSize: "16px",
                            marginBottom: "4px",
                          }}
                        >
                          GST Number
                        </h5>
                        <p style={{ fontSize: "13px", color: "#555" }}>
                          {payloadData?.gstNumber || "—"}
                        </p>
                      </div>
                    )}

                    {activeDoc === "PAN" && (
                      <div>
                        <div
                          style={{
                            width: "54px",
                            height: "54px",
                            backgroundColor: "#FF6A13",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            fontSize: "22px",
                            margin: "0 auto 8px",
                            boxShadow: "0 3px 6px rgba(255,106,19,0.4)",
                          }}
                        >
                          <i className="fa fa-id-card"></i>
                        </div>
                        <h5
                          style={{
                            color: "#FF6A13",
                            fontWeight: 600,
                            fontSize: "16px",
                            marginBottom: "4px",
                          }}
                        >
                          Franchise PAN No
                        </h5>
                        <p style={{ fontSize: "13px", color: "#555" }}>
                          {payloadData?.companyPanNumber || "—"}
                        </p>
                      </div>
                    )}

                    {/* Close button */}
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={closeDocumentModal}
                      style={{
                        position: "absolute",
                        top: "14px",
                        right: "18px",
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        padding: "6px",
                        width: "32px",
                        height: "32px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                      }}
                    ></button>
                  </div>

                  {/* ---------- Document Preview Section ---------- */}
                  <div
                    className="modal-body"
                    style={{
                      minHeight: 240,
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    {/* Zoom controls and preview area */}
                    <div
                      style={{
                        position: "relative",
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#fff",
                        borderRadius: "8px",
                        padding: "12px",
                        overflow: "hidden",
                      }}
                    >
                      {/* Zoom Icons */}
                      <div
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "16px",
                          display: "flex",
                          gap: "10px",
                          zIndex: 10,
                        }}
                      >
                        {/* Zoom Icons */}
                        <div
                          style={{
                            position: "absolute",
                            top: "12px",
                            right: "16px",
                            display: "flex",
                            gap: "10px",
                            zIndex: 10,
                          }}
                        >
                          {/* 🔍 Zoom In */}
                          <button
                            type="button"
                            onClick={() =>
                              setZoomLevel((prev) => Math.min(prev + 0.25, 3))
                            }
                            style={{
                              backgroundColor: "#FF6A13",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                              transition: "transform 0.2s ease",
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <i className="fa fa-search-plus"></i>
                          </button>

                          {/* ↺ Reset Zoom */}
                          <button
                            type="button"
                            onClick={() => {
                              const preview =
                                document.getElementById("doc-preview");
                              if (preview) {
                                preview.style.transition =
                                  "transform 0.3s ease, opacity 0.2s ease";
                                preview.style.opacity = "0.7";
                                setTimeout(() => {
                                  setZoomLevel(1);
                                  setOffset({ x: 0, y: 0 });
                                  preview.style.opacity = "1";
                                }, 150);
                              } else {
                                setZoomLevel(1);
                                setOffset({ x: 0, y: 0 });
                              }
                            }}
                            style={{
                              backgroundColor: "#999",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                              transition: "transform 0.2s ease",
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <i className="fa fa-undo"></i>
                          </button>

                          {/* 🔍 Zoom Out */}
                          <button
                            type="button"
                            onClick={() =>
                              setZoomLevel((prev) => Math.max(prev - 0.25, 0.5))
                            }
                            style={{
                              backgroundColor: "#FF6A13",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                              transition: "transform 0.2s ease",
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <i className="fa fa-search-minus"></i>
                          </button>
                        </div>
                      </div>

                      {/* Document Preview */}
                      <div
                        id="doc-preview"
                        onMouseDown={handleMouseDown}
                        style={{
                          transform: `scale(${zoomLevel}) translate(${
                            offset.x / zoomLevel
                          }px, ${offset.y / zoomLevel}px)`,
                          transformOrigin: "center center",
                          transition: isDragging
                            ? "none"
                            : "transform 0.25s ease",
                          cursor:
                            zoomLevel > 1
                              ? isDragging
                                ? "grabbing"
                                : "grab"
                              : "default",
                        }}
                      >
                        {docMime === "pdf" ? (
                          <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(
                              docPath
                            )}&embedded=true`}
                            title={docLabel}
                            style={{
                              width: "100%",
                              height: "60vh",
                              border: "none",
                              borderRadius: "8px",
                            }}
                          />
                        ) : [
                            "png",
                            "jpg",
                            "jpeg",
                            "gif",
                            "webp",
                            "bmp",
                          ].includes(docMime) ? (
                          <img
                            src={docPath}
                            alt={docLabel}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "60vh",
                              objectFit: "contain",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <p>No preview available for this file type.</p>
                            <p style={{ fontSize: 13, color: "#666" }}>
                              {
                                (
                                  docPath.split("fileName=")[1] ||
                                  docPath.split("/").pop() ||
                                  ""
                                ).split("?")[0]
                              }
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Meta + Actions */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 12,
                        marginTop: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 13,
                          color: "#333",
                          minWidth: "450px",
                          maxWidth: "680px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={
                          (
                            docPath.split("fileName=")[1] ||
                            docPath.split("/").pop() ||
                            ""
                          ).split("?")[0]
                        }
                      >
                        <div>
                          <strong>File:</strong>{" "}
                          {
                            (
                              docPath.split("fileName=")[1] ||
                              docPath.split("/").pop() ||
                              ""
                            ).split("?")[0]
                          }
                        </div>
                        <div>
                          <strong>Type:</strong> {docMime || "unknown"}
                        </div>
                      </div>

                      <div style={{ display: "flex", gap: 8 }}>
                        <a
                          href={docPath}
                          download
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-submit"
                          style={{ height: 38 }}
                        >
                          Download
                        </a>
                        <button
                          type="button"
                          className="btn btn-back"
                          onClick={closeDocumentModal}
                          style={{ height: 38 }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* backdrop */}
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </form>
    </>
  );
};

export default AddFranchise;
